import React from 'react'
import './Footer.css';
import Wave from '../Assets/img/wave.png';
import Insta from '@iconscout/react-unicons/icons/uil-instagram';
import Facebook from '@iconscout/react-unicons/icons/uil-facebook';
import Github from '@iconscout/react-unicons/icons/uil-github';
import Twitter from '@iconscout/react-unicons/icons/uil-twitter';
import Linkedin from '@iconscout/react-unicons/icons/uil-linkedin';

export const Footer = () => {
  return (
    <div className='footer' style={{fontFamily:"initial",  marginTop:"-30px",}} >
      <img src={Wave} alt="" style={{width: '100%'}}/>
     
      <div className='f-contact'>
      <h1 >Get In Touch</h1>
      <h2>You can reach out to me at</h2>
      <span> ✉️ 
        <a href='mailto:yhemant203@gmail.com' 
        >
        yhemant203@gmail.com
        </a>

        
      </span>
      <span>📞
        
        <a href="tel:+919911695440">
        +91 9911695440 </a>
        
        </span>

      <div className='f-icons'>
        <a href="https://www.linkedin.com/in/hemant-yadav-868296278/" target='_blank'><Linkedin color='white' size='3rem'/></a>
        <a href="https://www.instagram.com/hemantyadav3672/" target='_blank'><Insta color='white' size='3rem'/></a>
        {/* <a href="https://www.facebook.com/profile.php?id=100021146896242" target='_blank'><Facebook color='white' size='3rem'/></a> */}
        <a href="https://github.com/Hemant142/" target='_blank'><Github color='white' size='3rem'/></a>
      </div>
      <div>
      <p>Created By Hemant Yadav | © 2023. All Rights Reserved</p>
      </div>
      </div>


      
     
    </div>
  )
}
